module.exports = __webpack_public_path__ + "media/feelingBetter.429bd00f.mp3";